<template>
  <b-card v-if="display">
    <h6 class="card-title"><i class="far fa-edit"></i> {{ $t('views.exsbpaymentsmade.edit.edit') }}</h6>
    <vue-form :name="'formPaymentMadeToAgreements'" :state="formstate" @submit.prevent="onSubmit" class="p-0 col-sm-12 col-md-12">
      <b-row v-if="data.potencialRelations && data.potencialRelations.length > 0">
        <b-col>
          <label class="text-success"><b>{{$t("views.exsbpaymentsmade.form.potencialRelationsList")}}</b></label>
          <div v-for="(item, index) in data.potencialRelations" v-bind:key="'potencialRelations-' + index">
            <p><b-button variant="success" @click="setAgreementForPayment(item)" v-b-tooltip.hover :title="$t('buttons.selectUserAndAgreement')" class="ml-2 mr-2  btn-sm btn-circle"><i class="far fa-arrow-right"></i></b-button>
              {{$t("global.nameAndSurname")}}: {{ item.clientName }} {{ item.clientSurname }}, {{$t("views.userdata.form.firmname1")}}: {{ item.firmname1 }} {{ item.firmname2 }}, {{$t("views.agreements.show.agreementNumber")}}: {{ item.number }}, {{$t("views.agreements.show.debt")}}: {{ item.debtValue }}<span v-if="item.applicationName">, {{$t('views.application.show.title')}} {{item.applicationName}}</span>
            </p>
          </div>
          <label class="text-danger"><b>{{$t("views.exsbpaymentsmade.form.noPotencialRelationsOnList")}}:</b></label>
        </b-col>
      </b-row>
      <b-row v-if="!removing">
        <b-col v-if="datas.length > 0">
          <template v-for="(payment, index) in datas">
            <OtherAgreement v-bind:key="'payment-' + index" :removePayment="removePayment" :payment="payment" :paymentMade="paymentMade"
                            :index="index" :idAgreementOptions="idAgreementOptions" @changeValue="() => recalculatePayments()"></OtherAgreement>
          </template>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="form-group">
            <b-button class="btn btn-success mt-2" @click="addNewPayment()"><i class="fal fa-plus mr-2"></i>{{$t("views.exsbpaymentsmade.edit.split")}}</b-button>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="form-group">
            <div class="float-left">
              <input type="submit" :value="$t('buttons.send')" class="btn btn-success" />
              <b-btn variant="info" @click="cancelButton()">
                {{$t('buttons.cancel')}}
              </b-btn>
            </div>
          </div>
        </b-col>
      </b-row>
    </vue-form>
    <div class="col-sm-12 col-md-6">
    </div>
  </b-card>
</template>

<script>
import VueForm from 'vue-form'
import OtherAgreement from '@/components/Dashboard/Views/BusinessBundle/exsbpaymentsmade/components/OtherAgreement'
import ApiService from '@/utils/ApiService'
export default {
  name: 'PaymentMadeToAgreement',
  mixins: [VueForm],
  components: {
    OtherAgreement
  },
  props: {
    paymentMade: {
      type: Object,
      required: true
    },
    idAgreementOptions: {
      type: Array,
      required: true
    },
    cancelButton: {
      type: Function,
      required: true
    },
    fetchData: {
      type: Function,
      required: false
    },
    contentLoading: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      data: {},
      formstate: {},
      display: false,
      datas: [],
      datasChanger: 1,
      agreement: null,
      removing: false
    }
  },
  watch: {
    changeValue: function () {
      this.recalculatePayments()
    },
    'datasChanger': function (val) {
      this.recalculatePayments()
    }
  },
  created () {
    this.getPaymentMadeDataFromProps()
    this.display = true
  },
  methods: {
    setAgreementForPayment (agreement) {
      if (this.datas.length === 1 && !this.datas[0].idAgreement) {
        this.datas[0].idAgreement = '/core/public/index.php/api/e_x_a_b_agreements/' + agreement.id
      } else {
        let object = {
          addAccountToAgreement: 0,
          value: '0.00',
          idPayment: null,
          idAgreement: '/core/public/index.php/api/e_x_a_b_agreements/' + agreement.id,
          idBankPayment: this.data.idBankPayment['@id'],
          autoAdd: 0
        }
        this.datas.push(object)
      }
      this.datasChanger = !this.datasChanger
    },
    recalculatePayments (force = false) {
      if (this.datas.length > 1 || force === true) {
        let value = this.data.idBankPayment.value
        let totalValue = 0
        for (let d in this.datas) {
          totalValue = totalValue + parseFloat(this.datas[d].value)
          if (this.datas[d].value && d > 0) {
            this.datas[d].value = this.datas[d].value.replace(/[^0-9.]/g, '')
            value = value - parseFloat(this.datas[d].value)
          }
        }
        this.datas[0].value = parseFloat(value).toFixed(2)
      }
    },
    getPaymentMadeDataFromProps () {
      this.data = Object.assign({}, this.paymentMade)
      if (!this.data.idAgreement) {
        this.data.idAgreement = null
      }
      let paymentsItems = []
      for (let i in this.data.paymentsItems) {
        let object = {
          addAccountToAgreement: this.data.paymentsItems[i].addAccountToAgreement,
          value: this.data.paymentsItems[i].value,
          idAgreement: this.data.paymentsItems[i].idAgreement ? '/core/public/index.php/api/e_x_a_b_agreements/' + this.data.paymentsItems[i].idAgreement : null,
          idPayment: this.data.paymentsItems[i].idPayment,
          idBankPayment: this.data.idBankPayment['@id'],
          autoAdd: 0
        }
        paymentsItems.push(object)
      }
      this.datas = paymentsItems
    },
    removePayment (itemIndex) {
      this.removing = true
      this.datas.splice(itemIndex, 1)
      this.datasChanger = !this.datasChanger
      this.removing = false
      this.recalculatePayments(true)
    },
    addNewPayment () {
      let object = {
        addAccountToAgreement: 0,
        value: '0.00',
        idAgreement: null,
        idPayment: null,
        idBankPayment: this.data.idBankPayment['@id'],
        autoAdd: 0
      }
      this.datas.push(object)
      this.datasChanger = !this.datasChanger
    },
    onSubmit: function () { // send form
      if (this.formstate.$invalid) { // show error when form is not valid
        this.$swal({
          type: 'error',
          title: this.$t('notifications.onSubmit.formTitle'),
          showConfirmButton: true,
          timer: 2500
        })
      } else {
        if (this.data['@id']) { // update
          this.update()
        } else { // create new
          this.$Swal({
            type: 'error',
            title: this.$t('notifications.onSubmit.noOption'),
            showConfirmButton: true,
            timer: 2500
          })
        }
      }
    },
    async update () {
      let id = this.paymentMade['@id']
      this.data.paymentsItems = []
      for (let i in this.datas) {
        this.data.paymentsItems.push(this.datas[i])
      }
      const response = await new ApiService(`${id}/pairwithagreement`).put(this.data)
      if (response.status === 200) {
        this.data = {
          addAccountToAgreement: 0
        } // clear form data
        this.$router.go(-1)
      }
    }
  }
}
</script>
